/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import mbpLogger from 'mbp-logger';
import { string } from 'prop-types';

import { useDispatch, useSelector } from 'react-redux';

import { setOnePageCheckoutSaleForceABTest } from '../../../../../../../state/ducks/MfeCheckout/ducks/App/App-Actions';
import useSalesforcePersonalizedContentQuery from '../../../../../../helpers/Personalization/useSalesforcePersonalizedContentQuery';
import { getOnePageCheckoutSaleForceABTest } from '../../../../../../../state/ducks/MfeCheckout/ducks/App/App-Selectors';

const OnePageCheckoutABTest = ({ pageType }) => {
    const dispatch = useDispatch();
    const onePageCheckoutSaleForceABTestData = useSelector(getOnePageCheckoutSaleForceABTest);

    const { loading, data, error } = useSalesforcePersonalizedContentQuery({
        interactionName: 'Get Campaign - OnePageCheckout',
        targeting: { pageType },
        featureFlag: true,
        apolloOptions: {
            fetchPolicy: 'cache-first',
        },
        optInHoldoutParticipation: false,
        resolveIdentity: false,
    });

    if ((loading) || (!loading && !data && !error)) {
        return null;
    }

    if (error) {
        mbpLogger.logError({
            function: 'OnePageCheckoutABTest',
            appName: process.env.npm_package_name,
            module: 'mbp-checkout',
            message: 'One Page Checkoutt Salesforce AB test returned an error',
            jsError: error,
        });
    }

    if (
        data?.contentSF?.campaign?.campaignResponses?.[0]?.userGroup
        && data?.contentSF?.campaign?.campaignResponses?.[0]?.userGroup !== onePageCheckoutSaleForceABTestData?.campaign?.campaignResponses?.[0]?.userGroup
    ) {
        dispatch(setOnePageCheckoutSaleForceABTest(data.contentSF));
    }

    return null;
};

OnePageCheckoutABTest.propTypes = {
    pageType: string.isRequired,
};

export default OnePageCheckoutABTest;
